import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideHttpClient, withFetch} from '@angular/common/http';

import {routes} from './app.routes';
import {MypartHttpService} from './services/mypart-http.service';
import {Brain, Eye, Fingerprint, Layers, LucideAngularModule, Play, Shield, Target, User, Zap} from 'lucide-angular';

/**
 * Provides the background login initialization using Angular 19's provideAppInitializer
 * This is the official recommended replacement for APP_INITIALIZER in Angular 19
 */
export function provideBackgroundLogin() {
  return provideAppInitializer(() => {
    console.log('Running background login with provideAppInitializer...');
    const mypartHttpService = inject(MypartHttpService);
    mypartHttpService.login().subscribe({
      next: value => {
      }
    });
    // No need to return anything since login() doesn't return a Promise or Observable
    // If it did, we would return that Promise/Observable to delay initialization until it completes
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAnimations(), // Add animations support
    provideHttpClient(withFetch()), // Add HTTP client support
    provideBackgroundLogin(),
    // Register Lucide icons used in the application
    importProvidersFrom(LucideAngularModule.pick({
      Brain, Layers, Eye, Target, Fingerprint, User, Zap, Play, Shield
    }))
  ]
};
